<template>
  <div :class="breadcrumbClass">
    <div aria-label="breadcrumb">
      <nav
        v-show="items.length"
      >
        <ol class="breadcrumb">
          <li>
            <a
              :href="arp_linkBuilder({ name: 'Home' })"
              :data-ident="`breadCrumbHome`"
              @click.prevent="arp_linkClicker({ name: 'Home' })"
            >
              {{ $t('common:breadcrumbs.label.homepage') }}
            </a>
          </li>
          <li>
            <i class="icon"><icon-angle-right /></i>
          </li>
          <li
            v-for="(item,key) in loopItems"
            :key="key"

            :class="((key===0) ? '' : classLi)"
          >
            <a
              v-if="item.path || item.name"
              :data-locationType="item.label"
              :href="arp_linkBuilder(item)"
              :data-ident="`breadCrumb_${key}`"
              @click.prevent="arp_linkClicker(item)"
            >
              <span v-if="item.label !== ''">{{ $t(item.label) }}</span>
              <span v-if="item.labelName !== ''">{{ $t(item.labelName) }}</span>
              <span
                class="d-none"
              >{{ key + 1 }}</span>
            </a>
            <span v-else-if="item.labelName">{{ $t(item.labelName) }}</span>
            <span v-else>{{ $t(item.label) }}</span>
            <i class="icon"><icon-angle-right /></i>
          </li>
          <li v-if="buttonActive && items.length > 2">
            <button
              :class="classButton"
              type="button"
              @click="toggle"
            >
              ...
            </button>
            <i class="icon d-md-none"><icon-angle-right /></i>
          </li>
          <li>
            <span v-if="lastItem.label !== ''">{{ $t(lastItem.label) }}</span>
            <span v-if="lastItem.labelName !== ''">{{ $t(lastItem.labelName) }}</span>
          </li>
        </ol>
      </nav>
      <p
        v-show="headerSearchSubtitle"
        class="h3 mt-3"
      >
        {{ $t(headerSearchSubtitle) }}
      </p>
    </div>
  </div>
</template>

<script>

/* ICONS */
import AnchorRouterPush from 'mixins/AnchorRouterPush';
import IconAngleRight from 'ICON:IconAngleRight';

import 'scss/bootstrap/components/breadcrumb.scss';

export default {
  name: 'Breadcrumbs',
  components: {
    IconAngleRight,
  },
  mixins: [AnchorRouterPush],
  metaInfo() {
    return this.metaData;
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    isSeoPage: {
      type: Boolean,
      default: false,
    },
    headerSearchSubtitle: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      buttonActive: true,
    };
  },

  computed: {
    metaData() {
      const structuredDataBreadcrumbJson = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          name: this.$t('common:breadcrumbs.label.homepage'),
          item: `https://${process.env.CLIENTNAME}`,
        }],
      };

      this.items.filter((item) => item.path).forEach((item, i) => {
        structuredDataBreadcrumbJson.itemListElement.push({
          '@type': 'ListItem',
          position: i + 2,
          name: item.label,
          item: `https://${process.env.CLIENTNAME}${item.path}`,
        });
      });

      return {
        script: [{
          type: 'application/ld+json',
          json: structuredDataBreadcrumbJson,
          vmid: 'structuredDataBreadcrumbJson',
        }],
        __dangerouslyDisableSanitizers: ['script'],
      };
    },
    loopItems() {
      return this.items.slice(0, -1);
    },
    lastItem() {
      if (this.items.length) return this.items[this.items.length - 1 || 0];
      return { path: '', label: '' };
    },
    classButton() {
      return ((this.buttonActive === true) ? 'd-md-none pointer' : 'd-none');
    },
    classLi() {
      return ((this.buttonActive === true) ? 'd-none d-md-block' : '');
    },
    breadcrumbClass() {
      let className = ((this.isSeoPage === false) ? 'breadcrumbs-full' : 'breadcrumbs-header');
      if (this.position) {
        className = `${className}-${this.position}`;
      }
      return className;
    },
  },
  methods: {
    toggle() {
      this.buttonActive = !this.buttonActive;
    },

  },
};
</script>

<style lang="scss" scoped>
  ol.breadcrumb {
    background: none;
    margin: 0;
    padding: 0;

    @include font_size_s;
    $breadcrumb-divider: none;

    a,
    i {
      color: $color_grey_600;

      /* TODO float oder inline, du musst dich entscheiden ein */
      display: inline;
      text-decoration: none;
      border: none;
    }

    a {
      #app:not(.isTouchDevice) &:hover {
        color: var(--color_ci);
      }
    }

    i {
      margin: 0 0.15em 0 0.25em;
    }

    li {
      padding-right: 1px;
    }
  }

  span.pointer {
    cursor: pointer;
  }
</style>
